import React from 'react';
import Type from 'prop-types';
import cn from 'classnames';
import {
  Link,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import {
  FileCopy as FileCopyIcon,
  Call as CallIcon,
  Sms as SmsIcon,
} from "@mui/icons-material";
import { useCopyToClipboard, useTranslation } from 'hooks';
import styles from './PhoneMenu.module.css';

export const PhoneMenu = (props) => {
  const { anchorEl, closeMenu, phone, additionalWrapperStyles } = props;
  const { t } = useTranslation();
  const successCopyMessage = `${t('numberPhone')} ${phone} ${t(
    'successCopyToClipboard',
  )}`;
  const copyToClipboard = useCopyToClipboard(phone, successCopyMessage);

  return (
    <Menu
      id="menu"
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={closeMenu}
      anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      className={cn(styles.menuWrapper, ...additionalWrapperStyles)}
    >
      <MenuItem
        key="call"
        component={Link}
        href={`tel:${phone}`}
        underline="none"
        color="textPrimary"
      >
        <ListItemIcon>
          <CallIcon />
        </ListItemIcon>
        <ListItemText primary={t('call')} />
      </MenuItem>
      <MenuItem
        key="sms"
        component={Link}
        href={`sms://${phone}/`}
        underline="none"
        color="textPrimary"
      >
        <ListItemIcon>
          <SmsIcon />
        </ListItemIcon>
        <ListItemText primary={t('sendSms')} />
      </MenuItem>
      <MenuItem key="copy" onClick={() => copyToClipboard()}>
        <ListItemIcon>
          <FileCopyIcon />
        </ListItemIcon>
        <ListItemText primary={t('copy')} />
      </MenuItem>
    </Menu>
  );
};

PhoneMenu.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  anchorEl: Type.object,
  closeMenu: Type.func.isRequired,
  phone: Type.string.isRequired,
  additionalWrapperStyles: Type.arrayOf(Type.string),
};

PhoneMenu.defaultProps = {
  anchorEl: null,
  additionalWrapperStyles: [],
};
